// extracted by mini-css-extract-plugin
module.exports = {"customFooter":"Footer_customFooter_3OTQO","footerContent":"Footer_footerContent_3N6mC","spinAround":"Footer_spinAround_3soMq"};